import { Routes, Route, Navigate } from 'react-router-dom';
import { CalculatorScreen } from '@/screens/CalculatorScreen';
import { LevelsScreen } from '@/screens/LevelsScreen';
import { ReferenceScreen } from '@/screens/ReferenceScreen';
import { DocumentationScreen } from '@/screens/DocumentationScreen';
import { SettingsScreen } from '@/screens/SettingsScreen';

/** React Router v6 — 5 routes; unknown → / (TODO Task 1.18). */
export function router(): JSX.Element {
  return (
    <Routes>
      <Route path="/" element={<CalculatorScreen />} />
      <Route path="/levels" element={<LevelsScreen />} />
      <Route path="/reference" element={<ReferenceScreen />} />
      <Route path="/docs" element={<DocumentationScreen />} />
      <Route path="/settings" element={<SettingsScreen />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
